module.exports = __webpack_public_path__ + "img/charger-speeds-desktop.8fb92c55.png";